import { CALL_API } from 'redux-api-middleware'

export const USER_FOLLOW_REQUEST = 'USER_FOLLOW_REQUEST'
export const USER_FOLLOW_SUCCESS = 'USER_FOLLOW_SUCCESS'
export const USER_FOLLOW_FAILURE = 'USER_FOLLOW_FAILURE'

export function followUser(href, username, previousCount) {
  const meta = { username, wantFollowing: true, previousCount }
  return {
    [CALL_API]: {
      endpoint: href,
      method: 'POST',
      types: [
        { type: USER_FOLLOW_REQUEST, payload: meta, meta },
        { type: USER_FOLLOW_SUCCESS, meta },
        { type: USER_FOLLOW_FAILURE, meta },
      ],
    },
  }
}

export function unfollowUser(href, username, previousCount) {
  const meta = { username, wantFollowing: false, previousCount }
  return {
    [CALL_API]: {
      endpoint: href,
      method: 'DELETE',
      types: [
        { type: USER_FOLLOW_REQUEST, payload: meta, meta },
        { type: USER_FOLLOW_SUCCESS, meta },
        { type: USER_FOLLOW_FAILURE, meta },
      ],
    },
  }
}
